import { useForm as useVeeValidateForm } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/zod'

import type { FormOptions, GenericObject, TypedSchema } from 'vee-validate'
import type { ZodType, output, input } from 'zod'

type UseFormOptions<TSchema extends ZodType> = Omit<FormOptions<GenericObject, output<TSchema>, TypedSchema<input<TSchema>, output<TSchema>>>, 'validationSchema'> & {
  schema: TSchema
}

export function useForm <TSchema extends ZodType> (options: UseFormOptions<TSchema>) {
  const { schema, ...rest } = options
  return useVeeValidateForm({
    ...rest,
    validationSchema: toTypedSchema(schema as any) // TODO: Remove as any when zod is updated
  })
}
